'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateQuantity = function updateQuantity(data) {
  var containerId = data.id,
      quantity = data.quantity;


  $('[data-container-id="' + containerId + '"] ' + _Dom2.default.quantityValue).val(quantity);
};

exports.default = {
  update: updateQuantity
};